import { Deploy } from '@block-explorer/entities';
import { MessageData } from './types';
import {
  getNftTokensQuantityFromArgs,
  guardedDeriveSplitDataFromArguments,
} from './utils';

const prepareActionMessageData = (
  deploy: Deploy,
  getPublicKeyByAccountHash: (hash: string) => any
): MessageData => {
  const { entryPoint, args } = deploy;
  const entryPointName = entryPoint?.name || '';
  const actionName = {
    delist_token: 'Delist',
    list_token: 'List',
    accept_offer: 'Accept offer',
    cancel_offer: 'Cancel offer',
    make_offer: 'Make offer',
  };

  const offererHash = guardedDeriveSplitDataFromArguments(
    args.offerer,
    'Account'
  );
  const numOfTokens =
    (entryPointName === 'list_token' || entryPointName === 'delist_token') &&
    getNftTokensQuantityFromArgs(args);

  const actionOutcome: Partial<MessageData> = {
    ...(numOfTokens && { numOfTokens: numOfTokens }),
    ...(offererHash?.hash && {
      prefix1: 'from',
      account1: {
        accountHash: offererHash?.hash,
        publicKey: getPublicKeyByAccountHash(offererHash?.hash),
      },
    }),
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
    ...actionOutcome,
  };
};

const prepareActionMessageDataForHome = (
  deploy: Deploy,
  getPublicKeyByAccountHash: (hash: string) => any
): MessageData | null => {
  const { callerPublicKey, callerHash } = deploy;
  const messageObject = prepareActionMessageData(
    deploy,
    getPublicKeyByAccountHash
  );

  const actionOutcome: Partial<MessageData> = {
    callerPrefix: 'by',
    callerAccount: {
      publicKey: callerPublicKey || callerHash,
    },
  };

  if (messageObject === null) {
    return null;
  }

  return {
    ...messageObject,
    ...actionOutcome,
  };
};

export const csprMarkerMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return ['offerer'];
  };

  return {
    prepareActionMessageData,
    prepareActionMessageDataForHome,
    getRelevantAccountHashesFromArgs,
  };
};
